/**
 * เวอร์ชันของระบบ — **ไฟล์นี้ถูก generate อย่าแก้ด้วยมือ**
 *
 * สร้างโดย `node scripts/run-version.mjs` ซึ่งต้องรัน**ก่อน git ทุกครั้ง**
 * (ผู้ใช้สั่งไว้ 2026-09-17) แถบเมนูแสดงค่านี้แทนข้อความ "เฟส 1 · vertical slice"
 * เดิม — ป้ายที่บอกเฟสจะหยุดเป็นจริงในวันที่เฟสเปลี่ยน ส่วนเลขเวอร์ชันไม่
 */

/** semver ของระบบ เช่น `0.2.14` */
export const SYSTEM_VERSION: string = '0.1.117';

/**
 * commit ที่ build มาจาก หรือ `unknown` เมื่ออ่าน git ไม่ได้
 *
 * **`: string` ไม่ใช่ของประดับ** — ถ้าไม่ใส่ TypeScript จะ narrow เป็น literal
 * type ของ commit ที่ stamp ไว้รอบนั้น แล้วการเทียบกับ `'unknown'` ข้างล่าง
 * จะกลายเป็น `TS2367: no overlap` ซึ่งทำให้ `tsc -b` และ `npm run build` แดงทั้งคู่
 * (เจอจริงตอน `WO-P2-M11-004` 2026-09-17 — worker เป็นคนชี้จุดและบอกวิธีแก้)
 */
export const SYSTEM_COMMIT: string = '7fb9c3a';

/**
 * สิ่งที่แถบเมนูแสดง เช่น `v0.2.14 · a14f610`
 *
 * commit ต่อท้ายเพราะ **เลข semver อย่างเดียวบอกไม่ได้ว่าโค้ดชุดไหน** เวลา
 * ผู้ใช้แจ้งปัญหา สิ่งที่ต้องการคือสิ่งที่ย้อนกลับไปหา commit ได้ทันที
 */
export const SYSTEM_VERSION_LABEL =
  SYSTEM_COMMIT === 'unknown'
    ? `v${SYSTEM_VERSION}`
    : `v${SYSTEM_VERSION} · ${SYSTEM_COMMIT}`;
